import React, { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcadmin/digibooks/AdminDigiBooks.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

/* ── Categories ── */
const CATEGORIES = [
  "Computer Science",
  "Artificial Intelligence",
  "Islamic Studies",
  "Education",
  "Chemistry",
  "Mathematics",
  "Physics",
  "Botany",
  "Commerce",
  "Botony",
];

/* ══════════════════════════════════════════
   File Icon SVG
══════════════════════════════════════════ */
const FileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <line x1="10" y1="9"  x2="8" y2="9"/>
  </svg>
);

/* ══════════════════════════════════════════
   Upload / Edit Modal
══════════════════════════════════════════ */
const PDFModal = ({ book, onClose, onSaveSuccess }) => {
  const [form, setForm] = useState(
    book
      ? {
          title:        book.title,
          author:       book.author,
          dept:         book.dept,
          file:         null,
          fileName:     "",
          img:          null,
          imgPreview:   book.img ? `http://127.0.0.1:8000/storage/${book.img}` : null,
        }
      : {
          title:        "",
          author:       "",
          dept:         "",
          file:         null,
          fileName:     "",
          img:          null,
          imgPreview:   null,
        }
  );

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileRef                = useRef(null);
  const imgRef                 = useRef(null);
  const [errors, setErrors] = useState({});
  const { baseUrl, authToken,validateEBookForm, } = useContext(AppContext);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);

  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  /* ── PDF file ── */
  const handleFile = (e) => {
    const f = e.target.files[0];

    if (!f) return;

    // Error remove
    setErrors((prev) => ({
        ...prev,
        pdfFile: "",
    }));

    set("file", f);
    set("fileName", f.name);
};

  /* ── Cover image ── */
  const handleImage = (e) => {
    const f = e.target.files[0];

    if (!f) return;

    setErrors((prev) => ({
        ...prev,
        coverImage: "",
    }));

    const reader = new FileReader();

    reader.onload = (ev) =>
        setForm((p) => ({
            ...p,
            img: f,
            imgPreview: ev.target.result,
        }));

    reader.readAsDataURL(f);
};

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateEBookForm({
    title: form.title,
    author: form.author,
    department: form.dept,
    coverImage: form.img,
    pdfFile: form.file,
});
setErrors(validationErrors);

if (Object.keys(validationErrors).length > 0) {
    return;
}

    if (!book && !form.file) {
      Swal.fire({ icon: "warning", title: "Missing File", text: "Please select a PDF file." });
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("title",  form.title);
    formData.append("author", form.author);
    formData.append("dept",   form.dept);
    if (form.file) formData.append("pdf_file", form.file);
    if (form.img instanceof File) formData.append("img", form.img);

    const url = book
      ? `${baseUrl}/admin/ebooks/update/${book.id}`
      : `${baseUrl}/admin/ebooks/upload`;

    axios
      .post(url, formData, { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          Swal.fire({
            icon: "success",
            title: book ? "Updated!" : "Uploaded!",
            text: book ? "Ebook updated successfully." : "Ebook uploaded successfully.",
            confirmButtonText: "Great",
          });
          onSaveSuccess();
          handleClose();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Operation failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  return (
    <div
      className={`gcAdminDL-backdrop ${visible ? "gcAdminDL-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcAdminDL-modal ${visible ? "gcAdminDL-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="gcAdminDL-modal-header">
          <h5 className="gcAdminDL-modal-title">{book ? "Edit PDF" : "Upload PDF"}</h5>
          <button className="gcAdminDL-modal-close" onClick={handleClose} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="gcAdminDL-modal-body">

          <div className="gcAdminDL-form-group">
  <label className="gcAdminDL-form-label">
    {book ? "Cover Image (optional)" : "Cover Image"}
  </label>

  <div
    className={`gcAdminDL-cover-upload ${
      form.imgPreview ? "gcAdminDL-cover-upload--has" : ""
    }`}
    onClick={() => imgRef.current?.click()}
  >
    {form.imgPreview ? (
      <img
        src={form.imgPreview}
        alt="Cover"
        className="gcAdminDL-cover-preview"
      />
    ) : (
      <>
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>

        <p className="gcAdminDL-cover-text">
          Click to upload cover image
        </p>

        <p className="gcAdminDL-cover-hint">
          JPG, PNG (max 5MB)
        </p>
      </>
    )}
  </div>

  <input
    ref={imgRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleImage}
  />

  {errors.coverImage && (
    <small className="text-danger">
      {errors.coverImage}
    </small>
  )}
</div>
          <div className="gcAdminDL-form-group">
            <label className="gcAdminDL-form-label">Title</label>
            <input
className="gcAdminDL-form-input"
type="text"
placeholder="Book title"
value={form.title}
onChange={(e) => {
    set("title", e.target.value);
    setErrors((prev) => ({
        ...prev,
        title: "",
    }));
}}
/>

{errors.title && (
    <small className="text-danger">
        {errors.title}
    </small>
)}
          </div>

          <div className="gcAdminDL-form-group">
            <label className="gcAdminDL-form-label">Author</label>
            <input
className="gcAdminDL-form-input"
type="text"
placeholder="Author name"
value={form.author}
onChange={(e) => {
    set("author", e.target.value);
    setErrors((prev) => ({
        ...prev,
        author: "",
    }));
}}
/>

{errors.author && (
    <small className="text-danger">
        {errors.author}
    </small>
)}
          </div>

          <div className="gcAdminDL-form-group">
            <label className="gcAdminDL-form-label">Department</label>
            <div className="gcAdminDL-select-wrap">
              <select
                className="gcAdminDL-form-select"
                value={form.dept}
onChange={(e) => {
    set("dept", e.target.value);
    setErrors((prev) => ({
        ...prev,
        department: "",
    }));
}}
              >
                <option value="">Select Department</option>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              {errors.department && (
    <small className="text-danger">
        {errors.department}
    </small>
)}
              <span className="gcAdminDL-select-arrow">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </div>
          </div>

          <div className="gcAdminDL-form-group">
            <label className="gcAdminDL-form-label">
              {book ? "Replace PDF (optional)" : "PDF File *"}
            </label>
            <div className="gcAdminDL-upload-area" onClick={() => fileRef.current?.click()}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/>
                <path d="M14 2v6h6M12 12v6M9 15l3-3 3 3"/>
              </svg>
              <p className="gcAdminDL-upload-text">
                {form.fileName
                  ? form.fileName
                  : book ? "Click to replace PDF" : "Click to upload PDF"}
              </p>
              <p className="gcAdminDL-upload-hint">
                {book ? "Leave empty to keep existing file" : "PDF only (max 10MB)"}
              </p>
            </div>
            <input
  ref={fileRef}
  type="file"
  accept=".pdf"
  style={{ display: "none" }}
  onChange={handleFile}
/>

{errors.pdfFile && (
    <small className="text-danger">
        {errors.pdfFile}
    </small>
)}
          </div>

          <div className="gcAdminDL-modal-footer">
            <button type="submit" className="gcAdminDL-save-btn" disabled={loading}>
              {loading
                ? (book ? "Saving..." : "Uploading...")
                : (book ? "Save Changes" : "Upload PDF")}
            </button>
            <button type="button" className="gcAdminDL-cancel-btn" onClick={handleClose}>
              Cancel
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Delete Modal
══════════════════════════════════════════ */
const DeleteModal = ({ book, onClose, onDeleteSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const handleConfirm = () => {
    setLoading(true);
    axios
      .delete(`${baseUrl}/admin/ebooks/delete/${book.id}`,
        { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          Swal.fire({ icon: "success", title: "Deleted!", text: "Ebook deleted successfully.", confirmButtonText: "OK" });
          onDeleteSuccess();
          handleClose();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Delete failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong." });
      });
  };

  return (
    <div
      className={`gcAdminDL-backdrop ${visible ? "gcAdminDL-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcAdminDL-modal gcAdminDL-modal--sm ${visible ? "gcAdminDL-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="gcAdminDL-delete-icon">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
              stroke="#d63031" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h5 className="gcAdminDL-delete-title">Delete PDF?</h5>
        <p className="gcAdminDL-delete-msg">
          Are you sure you want to delete <strong>"{book.title}"</strong>?<br/>
          This action cannot be undone.
        </p>
        <div className="gcAdminDL-delete-actions">
          <button className="gcAdminDL-delete-cancel" onClick={handleClose}>Cancel</button>
          <button className="gcAdminDL-delete-confirm" onClick={handleConfirm} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

const AdminDigiBooks = () => {
  const [books,      setBooks]      = useState([]);
  const [search,     setSearch]     = useState("");
  const [showUpload, setShowUpload] = useState(false);
  const [editBook,   setEditBook]   = useState(null);
  const [deleteBook, setDeleteBook] = useState(null);
  const [visible,    setVisible]    = useState(false);
  const [loading,    setLoading]    = useState(false); // initial API fetch loading
  const [rowVisible, setRowVisible] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // pagination state
  const { baseUrl, baseUrlForFiles, authToken } = useContext(AppContext);

  // ── Pagination/search change hone par sirf current page (10 records)
  //    ki "loading" dikhane ke liye — poori list ek sath nahi ──
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  const loadAllEbooks = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/ebooks/all`,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success === true) setBooks(res.data.ebooks);
      })
      .catch((err) => console.error("Load ebooks error:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadAllEbooks(); }, []);

  const filtered = books.filter(b =>
    b.title?.toLowerCase().includes(search.toLowerCase())  ||
    b.author?.toLowerCase().includes(search.toLowerCase()) ||
    b.dept?.toLowerCase().includes(search.toLowerCase())
  );

  /* ── Pagination slice (sirf current page ka data table ko jayega) ── */
  const paginatedData = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Search change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {
    setRowVisible([]);
    paginatedData.forEach((_, i) => {
      setTimeout(() => {
        setRowVisible(prev => { const n = [...prev]; n[i] = true; return n; });
      }, i * 60);
    });
    // eslint-disable-next-line
  }, [search, books, currentPage]);

  /* ── Sirf visible (current page ke) records ki loading dikhayein:
     - Jab search change ho
     - Jab pagination se dusre page par jayen (next page ki 10 records ki loading)
     Poori list ek sath "pop" nahi hogi. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
  }, [currentPage, search]);

  const showLoader = loading || viewLoading;

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "short", day: "numeric", year: "numeric"
    });
  };

  return (
    <div className={`gcAdminDL-page ${visible ? "gcAdminDL-page--visible" : ""}`}>
      <Container fluid className="gcAdminDL-container">

        <div className="gcAdminDL-header">
          <h2 className="gcAdminDL-title">Digital Library</h2>
          <button className="gcAdminDL-upload-btn" onClick={() => setShowUpload(true)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"/>
            </svg>
            Upload PDF
          </button>
        </div>

        <div className="gcAdminDL-search-row">
          <div className="gcAdminDL-search-wrap">
            <input
              className="gcAdminDL-search-input"
              type="text"
              placeholder="Search PDFs..."
              value={search}
              onChange={e => { setSearch(e.target.value); setRowVisible([]); }}
            />
            <button className="gcAdminDL-search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.9"/>
                <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="gcAdminDL-table-wrap">
          {showLoader ? (
            <Loader message={loading ? "PDFs loading , Please wait..." : "Loading PDFs..."} />
          ) : (
            <>
              <table className="gcAdminDL-table">
                <thead>
                  <tr className="gcAdminDL-thead-row">
                    <th className="gcAdminDL-th">Title</th>
                    <th className="gcAdminDL-th">Author</th>
                    <th className="gcAdminDL-th">Department</th>
                    <th className="gcAdminDL-th">Date</th>
                    <th className="gcAdminDL-th gcAdminDL-th--center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((book, i) => (
                    <tr
                      key={book.id}
                      className={`gcAdminDL-tr ${rowVisible[i] ? "gcAdminDL-tr--visible" : ""}`}
                      style={{ transitionDelay: `${i * 0.05}s` }}
                    >
                      <td className="gcAdminDL-td gcAdminDL-td--title">
                        <div className="gcAdminDL-title-cell">
                          {book.img ? (
                            <img
                              src={`http://127.0.0.1:8000/storage/${book.img}`}
                              alt={book.title}
                              className="gcAdminDL-cover-thumb"
                              onError={e => { e.target.style.display = "none"; }}
                            />
                          ) : (
                            <span className="gcAdminDL-file-icon">
                              <FileIcon />
                            </span>
                          )}
                          <span className="gcAdminDL-title-text">{book.title}</span>
                        </div>
                      </td>

                      <td className="gcAdminDL-td gcAdminDL-td--author">{book.author}</td>

                      <td className="gcAdminDL-td">
                        <span className="gcAdminDL-badge">{book.dept}</span>
                      </td>

                      <td className="gcAdminDL-td gcAdminDL-td--date">{formatDate(book.created_at)}</td>

                      <td className="gcAdminDL-td gcAdminDL-td--center">
                        <div className="gcAdminDL-actions">
                          <a
                            href={`${baseUrlForFiles}/ebooks/${book.pdf_file}`}
                            target="_blank"
                            rel="noreferrer"
                            className="gcAdminDL-action-btn gcAdminDL-action-btn--view"
                            title="View PDF"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
                            </svg>
                          </a>

                          <button
                            className="gcAdminDL-action-btn gcAdminDL-action-btn--edit"
                            onClick={() => setEditBook(book)}
                            title="Edit"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
                              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>

                          <button
                            className="gcAdminDL-action-btn gcAdminDL-action-btn--delete"
                            onClick={() => setDeleteBook(book)}
                            title="Delete"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {filtered.length === 0 && (
                    <tr>
                      <td colSpan={5} className="gcAdminDL-td gcAdminDL-td--empty">No PDFs found.</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalItems={filtered.length}
                itemsPerPage={ITEMS_PER_PAGE}
                onPageChange={setCurrentPage}
              />
            </>
          )}
        </div>

      </Container>

      {(showUpload || editBook) && (
        <PDFModal
          book={editBook}
          onClose={() => { setShowUpload(false); setEditBook(null); }}
          onSaveSuccess={loadAllEbooks}
        />
      )}
      {deleteBook && (
        <DeleteModal
          book={deleteBook}
          onClose={() => setDeleteBook(null)}
          onDeleteSuccess={loadAllEbooks}
        />
      )}
    </div>
  );
};

export default AdminDigiBooks;